import useFieldState from "@/common/hooks/hook-wrappers/useInformedFieldStateWrapper"
import {
  useFieldApi 
} from "informed"
import {
  useEffect, useMemo 
} from "react"
import RadioGroup from "../../RadioGroup"
import FilterItemRadio from "./filterItemRadio"

const FilterItemRadioGroup = (props) => {
  const {
    filterApi,
    filterState,
    group,
    items,
    onApply = null,
    labels,
  } = props

  const radioItems = useMemo(() => {
    return items.map((item) => {
      const code = `item-${group}-${item.value}`

      return (
        <FilterItemRadio
          key={code}
          filterApi={filterApi}
          filterState={filterState}
          group={group}
          item={item}
          onApply={onApply}
          labels={labels}
        />
      )
    })
  }, [filterApi, filterState, group, items, labels, onApply])

  const fieldValue = useMemo(() => {
    if (filterState) {
      for (const item of items) {
        if (filterState.has(item)) {
          return item.value
        }
      }
    }

    return null
  }, [filterState, items])
  const field = `item-${group}`
  const fieldApi = useFieldApi(field)
  const fieldState = useFieldState(field)

  useEffect(() => {
    if (field && fieldValue === null) {
      fieldApi.reset()
    } else if (field && fieldValue !== fieldState.value) {
      fieldApi.setValue(fieldValue)
    }
  }, [field, fieldApi, fieldState.value, fieldValue])

  return <RadioGroup field={field}>{radioItems}</RadioGroup>
}

export default FilterItemRadioGroup
